import { motion } from 'framer-motion';
import SafeImage from './SafeImage';
import { SHOWCASE_GALLERY, IMAGE_FALLBACK_CHAIN } from '../config/siteImages';

const item = {
  hidden: { opacity: 0, y: 28 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: i * 0.05, ease: [0.25, 0.1, 0.25, 1] },
  }),
};

export default function ImageShowcase({ section }) {
  const eyebrow = section?.eyebrow || 'In the workshop & on site';
  const title = section?.title || 'Craft you can see';
  const subtitle =
    section?.subtitle ||
    'Real steel, real projects — a glimpse of how we design, fabricate, and deliver structural and architectural metalwork.';

  const items =
    section?.items?.length > 0
      ? section.items.map((g) => ({ src: g.imageUrl || g.src, alt: g.alt }))
      : SHOWCASE_GALLERY;

  return (
    <section className="showcase" id="showcase" aria-labelledby="showcase-heading">
      <div className="container">
        <div className="showcase-header">
          <motion.div
            className="eyebrow"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            {eyebrow}
          </motion.div>
          <motion.h2
            id="showcase-heading"
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.08 }}
          >
            {title}
          </motion.h2>
          <motion.p
            className="section-sub showcase-sub"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.55, delay: 0.14 }}
          >
            {subtitle}
          </motion.p>
        </div>
      </div>

      {/*
        Gallery grid: reorder or replace entries in SHOWCASE_GALLERY (siteImages.js).
      */}
      <div className="showcase-masonry-wrap">
        <div className="showcase-masonry">
          {items.map((itemData, i) => (
            <motion.figure
              key={itemData.src}
              className={`showcase-cell showcase-cell--${(i % 5) + 1}`}
              custom={i}
              variants={item}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-40px' }}
            >
              <SafeImage
                src={itemData.src}
                fallbackSrcs={IMAGE_FALLBACK_CHAIN}
                alt={itemData.alt}
                wrapperClassName="showcase-img-wrap"
                imgClassName="showcase-img"
              />
              <figcaption className="visually-hidden">{itemData.alt}</figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
